
import { defineComponent, ref } from 'vue'
export default defineComponent({
  name: 'ContextMenuSubmenu',
  props: {
    label: String,
    divider: {
      type: Boolean,
      default: false
    }
  },
  setup () {
    const hover = ref(false)

    function mouseEnterEvent () {
      hover.value = true
    }

    function mouseLeaveEvent () {
      hover.value = false
    }

    return { hover, mouseEnterEvent, mouseLeaveEvent }
  }
})
